var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { name: "step1" } },
    [
      _c("div", { staticClass: "noti-box top" }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.exam.acceptIdCard
                ? _vm.$t(
                    `preRegistration.step1.commentIdcard.${_vm.user.examIdType}`
                  )
                : _vm.$t("preRegistration.step1.comment")
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("StepBox", { attrs: { step: _vm.step, exam: _vm.exam } }),
      _vm._v(" "),
      _vm.readyInfo
        ? _c("i18n", {
            attrs: {
              tag: "h4",
              path: "preRegistration.step1.preparationGuide",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "guide",
                  fn: function () {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("preRegistration.step1.preparationCheck")
                          ) + " "
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2415821089
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "prereg-guide" }, [
        _vm.exam.acceptIdCard
          ? _c("div", { staticClass: "card-box" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "item-text" }, [
                _c("strong", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(
                          `preRegistration.step1.preparation.idCard.${_vm.user.examIdType}.title`
                        )
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(
                          `preRegistration.step1.preparation.idCard.${_vm.user.examIdType}.label`
                        )
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.useFront
          ? _c("div", { staticClass: "card-box" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "item-text" },
                [
                  _c("i18n", {
                    attrs: {
                      tag: "strong",
                      path: "preRegistration.step1.preparation.frontalMonitoringDevice.row1.title",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "inner",
                          fn: function () {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "preRegistration.step1.preparation.frontalMonitoringDevice.row1.inner"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1591363255
                    ),
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "preRegistration.step1.preparation.frontalMonitoringDevice.row2"
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.exam.sideMonitoring
          ? _c("div", { staticClass: "card-box" }, [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "item-text" },
                [
                  _c("i18n", {
                    attrs: {
                      tag: "strong",
                      path: "preRegistration.step1.preparation.sideMonitoringDevice.row1.title",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "inner",
                          fn: function () {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "preRegistration.step1.preparation.sideMonitoringDevice.row1.inner"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1481981472
                    ),
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "preRegistration.step1.preparation.sideMonitoringDevice.row2"
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("h4", [
        _vm._v(_vm._s(_vm.$t("preRegistration.step1.examEnvTestGuide.title"))),
      ]),
      _vm._v(" "),
      _c("h5", [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$t(
                "preRegistration.step1.examEnvTestGuide.chromeBrowser.title"
              )
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-box bg top" }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$t(
                "preRegistration.step1.examEnvTestGuide.chromeBrowser.row1"
              )
            ) +
            "\n    "
        ),
        _c("div", { staticClass: "btn-box bottom-sm" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-line-dark btn-sm icon icon-link",
              attrs: { type: "button" },
              on: { click: _vm.downloadChrome },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "preRegistration.step1.examEnvTestGuide.chromeBrowser.downloadChrome"
                    )
                  ) +
                  "\n      "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("h5", [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$t(
                "preRegistration.step1.examEnvTestGuide.importanceOfTesting.title"
              )
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-box bg top" }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$t(
                "preRegistration.step1.examEnvTestGuide.importanceOfTesting.row1"
              )
            ) +
            "\n    "
        ),
        _c("br"),
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$t(
                "preRegistration.step1.examEnvTestGuide.importanceOfTesting.row2"
              )
            ) +
            "\n    "
        ),
        _c("p", { staticClass: "strong-text" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t(
                  "preRegistration.step1.examEnvTestGuide.importanceOfTesting.row3"
                )
              ) +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("i18n", {
        attrs: {
          tag: "h5",
          path: "preRegistration.step1.examEnvTestGuide.cheating.title",
        },
        scopedSlots: _vm._u([
          {
            key: "inner",
            fn: function () {
              return [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "preRegistration.step1.examEnvTestGuide.cheating.comment"
                      )
                    )
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "card-box bg top" }, [
        _c("ol", [
          _c("li", [
            _c("span", [_vm._v("1")]),
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.exam.acceptIdCard
                    ? _vm.$t(
                        `preRegistration.step1.cheatingAction.row1Idcard.${_vm.user.examIdType}`
                      )
                    : _vm.$t("preRegistration.step1.cheatingAction.row1")
                ) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", [_vm._v("2")]),
            _vm._v(
              _vm._s(_vm.$t("preRegistration.step1.cheatingAction.row2.text1"))
            ),
            _c("br"),
            _vm._v(
              _vm._s(
                _vm.$t("preRegistration.step1.cheatingAction.row2.text2")
              ) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", [_vm._v("3")]),
            _vm._v(
              _vm._s(_vm.$t("preRegistration.step1.cheatingAction.row3.text1"))
            ),
            _c("br"),
            _vm._v(
              _vm._s(
                _vm.$t("preRegistration.step1.cheatingAction.row3.text2")
              ) + "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("span", [_vm._v("4")]),
            _vm._v(
              _vm._s(_vm.$t("preRegistration.step1.cheatingAction.row4")) +
                "\n      "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("h5", [
        _vm._v(_vm._s(_vm.$t("preRegistration.step1.questions.title"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-box bg top" },
        [
          _c("i18n", {
            attrs: { path: "preRegistration.step1.questions.label" },
            scopedSlots: _vm._u([
              {
                key: "contact",
                fn: function () {
                  return [
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          target: _vm.inquiryTarget,
                          href: _vm.inquiryLink,
                        },
                      },
                      [
                        _c("u", [
                          _c("strong", [_vm._v(_vm._s(_vm.exam.contactLink))]),
                        ]),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-box form-check-box" }, [
        _c("div", { staticClass: "text" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("preRegistration.step1.agreement.row1"))
          ),
          _c("br"),
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("preRegistration.step1.agreement.row2")) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-check form-check-lg" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.agreement,
                expression: "agreement",
              },
            ],
            attrs: { id: "check-1", type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.agreement)
                ? _vm._i(_vm.agreement, null) > -1
                : _vm.agreement,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.agreement,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.agreement = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.agreement = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.agreement = $$c
                }
              },
            },
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "check-1" } }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.$t("preRegistration.step1.agreement.checkbox"))
              ),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("img", {
        attrs: { src: require("@/assets/images/icon/ico_idcard.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("img", {
        attrs: {
          src: require("@/assets/images/icon/ico_pc_front.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("img", {
        attrs: { src: require("@/assets/images/icon/ico_mo.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }